export default (() => {
  class JumpToTop {
    constructor() {
      this.$jumpToTopEl = $('.jump-to-top');
      this.$mainNavDesktop = $('.main-navigation-desktop');
      this.$mainNavMobile = $('.main-navigation-mobile');
      this.$headerBanner = $('.header-microsite');
    }

    handleWindowScroll () {
      const self = this;
      let scrollPos = $(document).scrollTop();

      if(self.$mainNavDesktop.is(":visible")) {
        let mainNavDesktopBottom = self.$mainNavDesktop.offset().top + self.$mainNavDesktop.outerHeight(true);
        if(scrollPos > mainNavDesktopBottom) {
          self.$jumpToTopEl.addClass('active');
        } else {
          self.$jumpToTopEl.removeClass('active');
        }
      } else if(self.$mainNavMobile.is(":visible") ) {
        let headerBannerBottom = self.$headerBanner.offset().top + self.$headerBanner.outerHeight(true);
        if(scrollPos > headerBannerBottom - self.$mainNavMobile.outerHeight(true)) {
          self.$jumpToTopEl.addClass('active');
        } else {
          self.$jumpToTopEl.removeClass('active');
        }
      }
    }

    handleJumpToTopClick() {
      $('body, html').animate({
        scrollTop: 0,
      }, 700);
    }

    init() {
      const self = this;

      if(self.$jumpToTopEl.length < 1) {
        return;
      }

      self.handleWindowScroll();

      $(window).scroll(function() {
        self.handleWindowScroll();
      });

      $(self.$jumpToTopEl).on('click', function(e) {
        e.preventDefault();
        self.handleJumpToTopClick();
      });

    }
  }

  const jumpToTop = new JumpToTop();
  jumpToTop.init();

})();
